<template>
  <div
    aria-orientation="vertical"
    class="sidebar-right">
    <div class="email">
      <a href="mailto:soumyadiphazra@gmail.com">soumyadiphazra@gmail.com</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarEmail'
}
</script>

<style scoped>
</style>
